














































import { Component, Vue, Prop } from "vue-property-decorator";
// import { Company, Office, CompanyType } from "@/api/company-api";
import VDelete from "../../../components/VDelete.vue";
import SwitchButton from "@/components/SwitchButton.vue";
import SelectOption from "@/common/ui/presenters/select-option";
import { otherCompanyConstruction } from "../../api/other-company-construction-api";

/**
 * 他社工程の編集
 */
@Component({
  components: {
    VDelete,
    SwitchButton
  }
})
export default class OtherCompanyConstructionEdit extends Vue {
  @Prop({ required: true })
  otherCompanyConstruction!: otherCompanyConstruction[];
  @Prop({ default: () => [] }) constructionOptions!: SelectOption[];

  status = "";

  get templateOptions(): SelectOption[] {
    return this.$store.getters.serviceTaskTypeOptions.concat([
      { text: "非表示", value: "0" }
    ]);
  }

  submit() {
    this.status = "progressing";
    this.$emit("ok");
  }

  cancel() {
    this.$emit("cancel");
  }
}
